/**
 * Created by Vladislav on 03.06.2025.
 */

const SpaceRaceStartWindow = Prefab.createWindow("space_race_start_window", "spaceracestartwindow_prefab_json");